import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useState } from 'react';

const statusOptions = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
];

export const SchedStatusDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [status, setStatus] = useState(statusOptions[0].value);

  const submit = () => {
    rsrc.store(module, 'SCHED_STATUS_STORE_PLUGIN', { ids: data.ids, status });
    closeDialog();
  };

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth data-test-id="sched-status-dialog">
      <DialogTitle>Set Schedule Status</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ marginTop: '0.5rem' }}>
          <InputLabel>Status</InputLabel>
          <Select value={status} onChange={(e) => setStatus(e.target.value)} data-test-id="sched-status-selector">
            {statusOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} data-test-id="cancel-button">
          Cancel
        </Button>
        <Button onClick={submit} data-test-id="submit-button">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
